import * as React from 'react';

export function CloseIcon() {
    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.3252 1.32422L11.3252 11.3242M11.3252 1.32422L1.3252 11.3242" stroke="#868686" strokeWidth="2" />
        </svg>
    );
}